export const navLinks = [
  { label: "今日热议榜", href: "#hot" },
  { label: "传闻时间线", href: "#timeline" },
  { label: "争议焦点", href: "#focus" },
  { label: "瓜田合集", href: "#gallery" },
  { label: "网友热议", href: "#discuss" },
];

export const tickerItems = [
  "热榜更新：骚女qq 相关话题进入讨论区前三",
  "传闻时间线新增一条 9 月 10 日动态",
  "瓜田合集·聊天截图考古 已更新 3 条",
  "评论区正在热议：截图真假之辩",
  "网友投稿通道开放中，欢迎补充线索",
];

export const heroTags = [
  "骚女qq传闻",
  "骚女qq话题",
  "骚女qq爆料",
  "骚女qq热议",
  "瓜田合集",
  "评论区观察",
];

export const heroStats = [
  { value: "48", unit: "条", label: "累计收录话题" },
  { value: "12.6", unit: "万", label: "热议帖浏览" },
  { value: "3.4", unit: "万", label: "吃瓜群众围观" },
  { value: "24", unit: "h", label: "滚动更新频率" },
];

export const hotRanking = [
  {
    rank: 1,
    title: "骚女qq 话题再度冲上讨论榜前三",
    summary:
      "从昨夜开始，与骚女qq相关的讨论帖在多个社区同步升温，支持与质疑两派在评论区各执一词，话题热度仍在持续走高。",
    tag: "热议事件",
    heat: "9.8万",
    comments: "4,213",
    thumb:
      "https://readdy.ai/api/search-image?query=Close%20up%20still%20life%20of%20juicy%20sliced%20watermelon%20on%20a%20ceramic%20plate%2C%20warm%20golden%20afternoon%20light%2C%20rustic%20wooden%20table%2C%20soft%20shadows%2C%20editorial%20food%20photography%2C%20stylized%20warm%20tones%2C%20high%20detail%2C%20simple%20clean%20background%2C%20no%20text&width=400&height=400&seq=melonsite-hot-01&orientation=squarish",
  },
  {
    rank: 2,
    title: "传闻与澄清齐飞：一段聊天截图引发真假之争",
    summary:
      "围绕骚女qq的聊天记录截图在网络流传，有人认为是旧图翻炒，也有人给出「时间线对不上」的技术分析，真伪尚无定论。",
    tag: "传闻溯源",
    heat: "7.2万",
    comments: "3,087",
    thumb:
      "https://readdy.ai/api/search-image?query=Warm%20amber%20toned%20photo%20of%20a%20smartphone%20screen%20glowing%20with%20blurred%20chat%20bubble%20shapes%20on%20a%20rustic%20wooden%20table%2C%20cozy%20evening%20lamp%20light%2C%20soft%20bokeh%2C%20editorial%20still%20life%2C%20stylized%20warm%20palette%2C%20high%20detail%2C%20no%20readable%20text&width=400&height=400&seq=melonsite-hot-02&orientation=squarish",
  },
  {
    rank: 3,
    title: "一周瓜田复盘：从这次热议看网络人设的 AB 面",
    summary:
      "把骚女qq事件放进更长的时间轴来看，讨论的重心其实一直在变：从个人八卦慢慢转向对「人设运营」的集体吐槽。",
    tag: "话题盘点",
    heat: "6.5万",
    comments: "2,540",
    thumb:
      "https://readdy.ai/api/search-image?query=Stylized%20warm%20coral%20toned%20photo%20of%20a%20small%20megaphone%20resting%20on%20a%20textured%20concrete%20surface%2C%20dramatic%20soft%20side%20light%2C%20editorial%20composition%2C%20artistic%20minimal%20background%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=melonsite-hot-03&orientation=squarish",
  },
  {
    rank: 4,
    title: "老帖新翻：三年前的旧爆料为何又被提起",
    summary:
      "有网友翻出更早的旧帖，发现其中的说法与这次的新传闻存在重合。是巧合还是二次传播，评论区给出了两种完全不同的解读。",
    tag: "考古现场",
    heat: "5.1万",
    comments: "1,986",
    thumb:
      "https://readdy.ai/api/search-image?query=Warm%20toned%20artistic%20scene%20of%20two%20coffee%20cups%20on%20a%20cafe%20table%20with%20blurred%20silhouettes%20of%20people%20talking%20in%20the%20background%2C%20cozy%20amber%20light%2C%20editorial%20photography%2C%20stylized%20warm%20composition%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=melonsite-hot-04&orientation=squarish",
  },
  {
    rank: 5,
    title: "吃瓜群众画像：到底是谁在追这个话题",
    summary:
      "我们统计了讨论区的活跃时段与发言分布，发现围观人群远比想象中分散，深夜时段的互动量反而最高。",
    tag: "数据观察",
    heat: "4.3万",
    comments: "1,502",
    thumb:
      "https://readdy.ai/api/search-image?query=Stylized%20warm%20toned%20photo%20of%20an%20open%20vintage%20notebook%20with%20blurred%20handwriting%20and%20a%20brass%20magnifying%20glass%20on%20a%20wooden%20desk%2C%20soft%20golden%20hour%20light%2C%20editorial%20mood%2C%20artistic%20composition%2C%20high%20detail%2C%20no%20readable%20text&width=400&height=400&seq=melonsite-hot-05&orientation=squarish",
  },
  {
    rank: 6,
    title: "话题延伸：这次热议带火的几个周边梗",
    summary:
      "每次大型吃瓜现场都会留下几个「名场面」。这次围绕骚女qq的讨论，也意外捧红了几句被反复引用的评论区金句。",
    tag: "梗百科",
    heat: "3.6万",
    comments: "1,214",
    thumb:
      "https://readdy.ai/api/search-image?query=Warm%20cream%20toned%20photo%20of%20stacked%20old%20envelopes%20and%20a%20red%20wax%20seal%20on%20a%20linen%20surface%2C%20soft%20natural%20light%2C%20mysterious%20editorial%20still%20life%2C%20stylized%20warm%20palette%2C%20high%20detail%2C%20no%20readable%20text&width=400&height=400&seq=melonsite-hot-06&orientation=squarish",
  },
];

export const timeline = [
  {
    date: "09 / 10",
    title: "话题再度升温，冲上讨论区前列",
    desc: "多条相关帖子在同一时段被集中回复，话题热度曲线出现明显陡峭的一段。",
    source: "综合讨论区",
    status: "持续中",
  },
  {
    date: "09 / 08",
    title: "一段聊天截图开始在社区流传",
    desc: "截图内容被反复转载，但发布时间与上下文很快成为争议焦点。",
    source: "网友投稿",
    status: "真伪存疑",
  },
  {
    date: "09 / 04",
    title: "讨论区出现「时间线分析」长帖",
    desc: "有网友逐条比对公开发言与截图细节，认为其中存在对不上的地方。",
    source: "长帖整理",
    status: "技术分析",
  },
  {
    date: "08 / 30",
    title: "传闻进入二次传播阶段",
    desc: "话题从单一社区扩散到多个平台，出现大量二次加工与再解读版本。",
    source: "跨平台观察",
    status: "已扩散",
  },
  {
    date: "08 / 22",
    title: "相关话题首次进入大众视野",
    desc: "最初的讨论规模有限，更多是零散的提问与好奇，尚未形成集中热议。",
    source: "早期记录",
    status: "起点",
  },
];

export const focuses = [
  {
    tag: "焦点 01",
    title: "截图真假之辩",
    desc: "同一张图被读出了完全不同的结论。支持方强调细节吻合，质疑方则抓住时间线上的矛盾点，双方至今没能说服彼此。",
    stat: "3,087 条讨论",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20toned%20editorial%20photo%20of%20a%20magnifying%20glass%20lying%20on%20blurred%20newspaper%20pages%20and%20glasses%20on%20a%20dark%20wooden%20desk%2C%20soft%20golden%20light%2C%20investigative%20mood%2C%20stylized%20warm%20composition%2C%20high%20detail%2C%20no%20readable%20text&width=960&height=600&seq=melonsite-focus-01&orientation=landscape",
  },
  {
    tag: "焦点 02",
    title: "人设与过往发言",
    desc: "网友把过往的公开表达重新拼在一起，试图找出「前后是否一致」。讨论逐渐从个人八卦，转向对网络人设本身的集体反思。",
    stat: "2,140 条讨论",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20warm%20toned%20photo%20of%20an%20ornate%20vintage%20mirror%20against%20a%20textured%20terracotta%20wall%20with%20soft%20shadow%20play%2C%20artistic%20editorial%20composition%2C%20warm%20amber%20light%2C%20high%20detail%2C%20no%20text&width=960&height=600&seq=melonsite-focus-02&orientation=landscape",
  },
  {
    tag: "焦点 03",
    title: "热度背后的推手",
    desc: "为什么偏偏是这个时候火起来？有人复盘了传播路径，认为平台推荐与搬运号放大了声量，热度并不完全等于关注度。",
    stat: "1,760 条讨论",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20toned%20photo%20of%20blurred%20crowd%20silhouettes%20gathered%20under%20soft%20amber%20string%20lights%20at%20dusk%2C%20bokeh%20glow%2C%20stylized%20editorial%20street%20scene%2C%20cinematic%20depth%2C%20high%20detail%2C%20no%20text&width=960&height=600&seq=melonsite-focus-03&orientation=landscape",
  },
];

export const gallery = [
  {
    title: "聊天截图考古",
    tag: "合辑",
    views: "2.1万",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20toned%20stylized%20photo%20of%20a%20wall%20of%20small%20glowing%20phone%20screens%20with%20blurred%20colorful%20shapes%20in%20a%20dim%20room%2C%20amber%20and%20coral%20glow%2C%20editorial%20artistic%20composition%2C%20high%20detail%2C%20no%20readable%20text&width=800&height=600&seq=melonsite-gal-01&orientation=landscape",
  },
  {
    title: "评论区金句集",
    tag: "精选",
    views: "1.8万",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20toned%20photo%20of%20a%20wall%20covered%20with%20colorful%20sticky%20notes%20and%20pinned%20paper%20scraps%20in%20soft%20amber%20light%2C%20creative%20studio%2C%20editorial%20composition%2C%20stylized%20warm%20palette%2C%20no%20readable%20text&width=800&height=600&seq=melonsite-gal-02&orientation=landscape",
  },
  {
    title: "瓜田现场直击",
    tag: "现场",
    views: "1.5万",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20golden%20toned%20photo%20of%20fresh%20watermelons%20piled%20at%20a%20rustic%20market%20stall%20with%20soft%20afternoon%20light%2C%20editorial%20street%20photography%2C%20stylized%20warm%20palette%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=melonsite-gal-03&orientation=landscape",
  },
  {
    title: "传闻溯源档案",
    tag: "档案",
    views: "1.2万",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20warm%20toned%20photo%20of%20a%20rainy%20city%20street%20at%20night%20with%20amber%20and%20coral%20reflected%20lights%20and%20blurred%20bokeh%2C%20cinematic%20editorial%20mood%2C%20high%20detail%2C%20no%20readable%20text&width=800&height=600&seq=melonsite-gal-04&orientation=landscape",
  },
];

export const comments = [
  {
    user: "只想安静吃瓜",
    initial: "瓜",
    time: "12 分钟前",
    content: "理性吃瓜，截图真假先别急着下定论，等时间线分析帖更新完再说。",
    likes: 862,
    replies: 43,
    tone: "accent",
  },
  {
    user: "深夜刷帖选手",
    initial: "深",
    time: "38 分钟前",
    content: "说实话这种话题三天两头就火一次，真正值得看的其实是评论区，梗比正文好看。",
    likes: 651,
    replies: 27,
    tone: "primary",
  },
  {
    user: "时间线考据党",
    initial: "考",
    time: "1 小时前",
    content: "整理了一下公开表达和截图的时间点，有几处确实对不上，建议大家都先看原帖再转。",
    likes: 1204,
    replies: 96,
    tone: "secondary",
  },
  {
    user: "路过看看热闹",
    initial: "路",
    time: "2 小时前",
    content: "不站队，就想知道这个话题最后会怎么收场，希望别再有人被误伤。",
    likes: 438,
    replies: 12,
    tone: "accent",
  },
  {
    user: "梗百科小编",
    initial: "梗",
    time: "3 小时前",
    content: "这次带火的几句评论区金句已经收录进瓜田合集了，大家还有补充的吗？",
    likes: 322,
    replies: 58,
    tone: "primary",
  },
];

export const pollOptions = [
  { label: "先看证据，再决定信不信", votes: 4820 },
  { label: "纯粹围观，不站任何一边", votes: 3160 },
  { label: "觉得是旧闻翻炒，热度虚高", votes: 2140 },
  { label: "更想看评论区的神回复", votes: 1580 },
];

export const tagCloud = [
  "骚女qq传闻",
  "骚女qq话题",
  "骚女qq热议",
  "骚女qq爆料",
  "骚女qq瓜",
  "骚女qq事件",
  "瓜田合集",
  "网络人设",
  "评论区观察",
  "传闻溯源",
  "热度复盘",
  "梗百科",
  "长帖整理",
  "时间线考据",
  "跨平台观察",
];

export const footerColumns = [
  {
    title: "内容分区",
    links: [
      { label: "今日热议榜", href: "#hot" },
      { label: "传闻时间线", href: "#timeline" },
      { label: "争议焦点", href: "#focus" },
      { label: "瓜田合集", href: "#gallery" },
    ],
  },
  {
    title: "参与讨论",
    links: [
      { label: "网友热议", href: "#discuss" },
      { label: "互动投票", href: "#poll" },
      { label: "话题标签", href: "#tags" },
      { label: "订阅快讯", href: "#subscribe" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "内容说明", href: "#subscribe" },
      { label: "投稿方式", href: "#subscribe" },
      { label: "免责声明", href: "#subscribe" },
      { label: "更新日志", href: "#hot" },
    ],
  },
];